import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ConnectPageComponent } from '../component/page/connect-page/connect-page.component';
import { ServiceTechnologyProvidersComponent } from '../component/page/service-technology-providers/service-technology-providers.component';

const routes: Routes = [
  { path: 'connect', component: ConnectPageComponent },
  { path: 'service-technology-providers', component: ServiceTechnologyProvidersComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppConnectRoutingModule {}
